import { BaseFiltersInput } from "@core/store/types/admin/statistic/common/generic/statisticFilters";
import cities from "@core/services/common/lists/graphql/cities.graphql";
import Service from "@core/services/common/Service";
import { AxiosPromise } from "axios";

export class CitiesService extends Service {
  public static getCitiesFilters (
    filters?: BaseFiltersInput,
    initialOffers?: BaseFiltersInput,
    limit = 25,
    offset = 0
  ): Promise<AxiosPromise> {
    try {
      const initialOffersLimit = initialOffers?.id?.length || 0;

      return this.api.get("", {
        params: {
          query: cities,
          variables: {
            limit,
            offset,
            filters,
            sort: "name",
            order: "ASC",
            initialOffers,
            initialOffersLimit
          }
        }
      });
    } catch (e) {
      throw e;
    }
  }
}
